import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.overview.widget.top5');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-overview-widget-top5',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.overview.widget.top5/view.scss */
/* src/app/portal.overview.widget.top5/view.scss: no such file or directory */`],
})
export class PortalOverviewWidgetTop5Component implements OnInit {
    @Input() data!: ResearcherData;
    @Input() period: any;

    public researcher: any;
    public periodStart: number;
    public periodEnd: number;
    public products: any[] = [];

    topBoxes: any[] = [];
    years: number[] = [];
    selectedYear: number;

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        await this.service.init();
        this.mapping();
        this.updateYears();
        await this.loadData();
        await this.service.render();
    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.products = this.data.products;
        this.periodEnd = this.period.end;
        this.periodStart = this.period.start;
        this.service.render();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            const curr = changes['period'].currentValue;
            this.periodStart = curr?.start;
            this.periodEnd = curr?.end;
            this.loadData();
        }
    }

    private updateYears() {
        if (this.periodStart && this.periodEnd && this.periodStart <= this.periodEnd) {
            this.years = Array.from(
                { length: this.periodEnd - this.periodStart + 1 },
                (_, i) => this.periodStart + i
            );
            this.selectedYear = this.periodEnd;
        } else {
            this.years = [];
        }
    }

    public async onYearChange() {
        await this.loadData();
        await this.service.render();
    }

    private async loadData() {
        // if (!this.selectedYear) return;

        // const filtered = (this.products ?? []).filter(
        //     p => Number(p.pub_year) === Number(this.selectedYear)
        // );

        if (!this.products?.length || !this.periodStart || !this.periodEnd) return;

        const filtered = this.products.filter(p => {
            const year = Number(p.pub_year);
            return year >= this.periodStart && year <= this.periodEnd;
        });

        const idFreq: Record<string, number> = {};
        const nameFreq: Record<string, number> = {};

        for (const p of filtered) {
            // --- ID 집계 ---
            const ids = (p.auth_list || "")
                .split(";")
                .map(x => x.trim())
                .filter(Boolean);
            for (const id of ids) {
                if (id === this.researcher?.auth_id) continue;
                idFreq[id] = (idFreq[id] || 0) + 1;
            }

            // --- 이름 집계 ---
            const names = (p.kr_coauth || "")
                .split(";")
                .map(x => x.trim())
                .filter(Boolean);
            for (const name of names) {
                if (!name || name === this.researcher?.kr_name) continue;
                nameFreq[name] = (nameFreq[name] || 0) + 1;
            }
        }

        // --- 이름 기준 Top5 ---
        const sortedNames = Object.entries(nameFreq)
            .sort((a, b) => b[1] - a[1])
            .map(([name]) => name)
            .slice(0, 5);

        // --- ID 기준 (API 조회용으로 top20 정도 확보) ---
        const sortedIds = Object.entries(idFreq)
            .sort((a, b) => b[1] - a[1])
            .map(([id]) => id)
            .slice(0, 20);

        // --- API로 ID → 이름 매핑 ---
        let idToName: Record<string, string> = {};
        try {
            const { code, data } = await wiz.call("get_authors_by_ids", {
                ids: sortedIds.join(","),
            });
            if (code === 200 && data?.authors) {
                // 예시: data.authors = [{ id: 'ADPER0000099964', name: '김길동' }, ...]
                idToName = Object.fromEntries(data.authors.map((a: any) => [a.id, a.name]));
            }
        } catch (err) {
            console.warn("저자 이름 조회 실패:", err);
        }

        // --- 이름 기준으로 top5를 만들고, 매칭되는 경우 id 붙이기 ---
        const topResearchers = sortedNames.map(name => {
            const matched = Object.entries(idToName).find(
                ([, n]) => (n ?? "").trim() === (name ?? "").trim()
            );
            return matched
                ? { id: matched[0], name, linked: true }
                : { id: null, name, linked: false };
        });

        // --- 공동 연구기관 집계 (org_id 기준) ---
        const orgFreq: Record<string, number> = {};
        for (const p of filtered) {
            if (p.org_id) {
                orgFreq[p.org_id] = (orgFreq[p.org_id] || 0) + 1;
            }
        }

        const topOrgIds = Object.entries(orgFreq)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 5)
            .map(([orgId]) => orgId);

        let topInstitutes: { name: string }[] = [];

        if (topOrgIds.length > 0) {
            try {
                // 한 번에 batch 호출
                const { code, data } = await wiz.call("get_organizations", { ids: topOrgIds.join(",") });
                if (code === 200 && data?.organizations) {
                    topInstitutes = data.organizations.map((org: any) => ({
                        name: org.kr_name ?? org.en_name ?? org.org_id
                    }));
                }
            } catch (err) {
                console.error("기관 batch 조회 실패:", err);
                // fallback → org_id만 표시
                topInstitutes = topOrgIds.map(orgId => ({ name: orgId }));
            }
        }

        // --- 연구주제 ---
        const keywordFreq: Record<string, number> = {};
        for (const p of filtered) {
            let raw = p.kr_keywords?.trim();
            if (!raw) raw = p.en_keywords?.trim();

            if (raw) {
                const parts = raw.split(';')
                    .map(x => x.trim())
                    .filter(x => x.length > 0);

                for (const kw of parts) {
                    keywordFreq[kw] = (keywordFreq[kw] || 0) + 1;
                }
            }
        }

        const topTopics = Object.entries(keywordFreq)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 5)
            .map(([name]) => ({ name }));

        // --- TOP BOXES 세팅 ---
        this.topBoxes = [
            { title: 'TOP-5 협력 연구자', data: topResearchers },
            { title: 'TOP-5 공동 연구기관', data: topInstitutes },
            { title: 'TOP-5 연구주제', data: topTopics },
        ];
        await this.service.render();
    }


    public detail(user: { id: string; name: string }) {
        if (!user?.id || !this.researcher?.org_id) return;
        window.location.href = `/detail/${user.id}`;
    }

    trackByBox = (_: number, box: any) => box.title;
    trackByName = (_: number, item: { name: string }) => item.name;
}

export default PortalOverviewWidgetTop5Component;